export default "__VITE_ASSET__f6e77187__"